import { createState } from "states/createState";

export const { listState, currentIdState, itemState } = createState<JobView>({
  name: "job",
  getId: ({ _id }) => _id,
});
